import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { BaselineDeviation } from '../../../interfaces/ng-oct-report.interface';

@Component({
    selector: 'lib-tenant-security-control',
    templateUrl: './tenant-security-control.component.html',
    styleUrls: ['./tenant-security-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TenantSecurityControlComponent implements OnInit {
    @Input() categories: string[] = [];

    loaded: boolean = false;
    @Input() tenantBaselineDeviationsByCategory: {
        [category: string]: { [name: string]: BaselineDeviation | null };
    } | null = {};

    constructor() {}

    ngOnInit() {
        this.loaded = this.tenantBaselineDeviationsByCategory !== null;
    }

    public trackByCategory(category: any) {
        return category;
    }

    public trackByName(baseline_name: any) {
        return baseline_name.key;
    }
}
